export const PSSRStatusNames = { Deleted: 'Deleted' };
